// extracted by mini-css-extract-plugin
export var content = "GenericSection-module--content--5d2c5";
export var ctaBtn = "GenericSection-module--ctaBtn--f0a57";
export var wrapper = "GenericSection-module--wrapper--16be8";